<i18n src='@/locale/payment-localization.json'></i18n>

<template>
	<div class="text-center">
	  <v-dialog
		v-model="dialog"
		width="auto"
	  >
		<template v-slot:activator="{ on, attrs }">
			<slot name="activator" :attrs="attrs" :on="on">
				<v-btn
					color="primary"
					v-bind="attrs"
					v-on="on"
				>
					{{ $t('Open') }}
				</v-btn>
			</slot>
		</template>
  
		<v-card>
		  <v-card-text>
			<v-data-table
            	dense
				:headers="headers"
				:items="details"
				:items-per-page="-1"
				class="elevation-1"
				hide-default-footer
			>
				<template v-slot:item.left_actions="{ item }">
					<v-btn
						icon
						small
						@click="print(item.PkId, item.IsFromArchive)"
					>
						<v-icon>mdi-printer</v-icon>
					</v-btn>
					<culture-select @select="culture => printForLang(item.PkId, item.IsFromArchive, culture)" />
				</template>
				<template v-slot:item.CreatedAtDateTime="{ item }">
					{{ formatDatetime(item.CreatedAtDateTime) }}
				</template>
				<template v-slot:item.right_actions="{ item }">
					<workflow-request
						url="/Mio/DeleteBalanceDetails"
						:request-data="{ id: item.PkId }"
						@response="response => onDeleteResponse(response, item.PkId)"
					>
						<template v-slot:activator="{ makeRequest }">
							<v-btn
								icon
								small
								@click="deletePayment(makeRequest, item.PkId)"
							>
								<v-icon>mdi-content-cut</v-icon>
							</v-btn>
						</template>
					</workflow-request>
				</template>
			</v-data-table>
		  </v-card-text>
		  <v-card-actions>
			<v-spacer/>
			<v-btn color="primary" @click="dialog = false">{{ $t('Close') }}</v-btn>
		  </v-card-actions>
		</v-card>
	  </v-dialog>
	</div>
</template>

<script>
import { getDateTimeStr, swalConfirm } from '@/script/common';
import paymentService from '@/service/payment-service';
import CultureSelect from '@/component/culture-select.vue';
import WorkflowRequest from '../workflow/workflow-request.vue';

export default {
	components: {
		CultureSelect,
		WorkflowRequest
	},
	props: {
		organizationCode: {
			type: Number
		},
		personCode: {
			type: Number
		},
		date: {
			type: String
		}
	},
    data() {
        return {
            dialog: false,
			headers: [
                { text: '', value: 'left_actions', sortable: false, },
                { text: this.$t('History.Type'), value: 'HistoryTypeString', sortable: false, },
                { text: this.$t('History.Number'), value: 'HistoryNumber', sortable: false, },
                { text: this.$t('Sab'), value: 'Sab', sortable: false, },
                { text: this.$t('Date'), value: 'Date', sortable: false, },
                { text: this.$t('Cost'), value: 'Cost', sortable: false, },
                { text: '', value: 'PaymentTypeSymbol', sortable: false, },
                { text: this.$t('Text'), value: 'Text', sortable: false, },
                { text: this.$t('CreatedBy'), value: 'CreatedByDisplay', sortable: false, },
                { text: this.$t('CreatedAt'), value: 'CreatedAtDateTime', sortable: false, },
                { text: '', value: 'right_actions', sortable: false, },
			],
			details: []
        };
    },
	watch: {
		dialog(val) {
			this.details = [];
			if (val) {
				this.GetBalanceDetails();
			}
		}
	},
    methods: {
        GetBalanceDetails() {
			if (this.organizationCode > 0) {
				paymentService
					.getOrganizationBalanceDetails(this.organizationCode, this.date)
					.then(resp => {
						this.details = resp;
					});
			} else if (this.personCode > 0) {
				paymentService
					.getPersonBalanceDetails(this.personCode, this.date)
					.then(resp => {
						this.details = resp;
					});
			} else {
				this.details = [];
			}
        },
		formatDatetime(datetime) {
			return datetime ? getDateTimeStr(datetime) : '';
		},
		print(id, isFromArchive) {
			window.open(`/Mio/PrintBalance?id=${id}&isFromArchive=${isFromArchive.toString().toLowerCase()}`);
		},
		printForLang(id, isFromArchive, lang) {
			window.open(`/Mio/PrintBalance?id=${id}&isFromArchive=${isFromArchive.toString().toLowerCase()}&lang=${lang}`);
		},
		deletePayment(makeRequest, id) {
			if (id > 0) {
				swalConfirm.fire({
					allowEnterKey: true
				}).then(resp => {
					if (resp.isConfirmed) {
						makeRequest();
					}
				});
			}
		},
		onDeleteResponse(resp, id) {
			if (resp && resp.success) {
				this.details = this.details.filter(i => i.PkId !== id);
				this.$emit('update');
			}
		}
    },
};
</script>

<style lang="scss" scoped>
</style>